
import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import OpportunityForm from "./OpportunityForm";
import { useOpportunities, OpportunityFormValues } from "@/hooks/opportunities";

interface OpportunityDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

const OpportunityDialog: React.FC<OpportunityDialogProps> = ({ isOpen, setIsOpen }) => {
  const { form, handleSubmit } = useOpportunities();
  
  // Create a wrapper function that will be passed to the OpportunityForm
  const onFormSubmit = async (values: OpportunityFormValues) => {
    await handleSubmit(values);
  };
  
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>Post a New Opportunity</DialogTitle>
          <DialogDescription>
            Share details about an opportunity with the community.
          </DialogDescription>
        </DialogHeader>

        <OpportunityForm 
          form={form} 
          onSubmit={onFormSubmit}
          setIsDialogOpen={setIsOpen} 
        />
      </DialogContent>
    </Dialog>
  );
};

export default OpportunityDialog;
